var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#D8D8D8",
    fillRule: "nonzero",
    cx: 96,
    cy: 96,
    r: 96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4 39.906h112.941v112.94H38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.663 129.318v-14.323m22.916 14.323v-14.323m-37.238 14.323v-14.323c0-14.238 11.542-22.915 25.78-22.915 14.238 0 25.78 8.677 25.78 22.915v14.323M97.121 92.08c7.91 0 14.322-6.412 14.322-14.322 0-7.91-6.412-14.323-14.322-14.323-7.91 0-14.322 6.413-14.322 14.323S89.211 92.08 97.121 92.08z",
    stroke: "#666",
    strokeWidth: 9.412
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/avatar-placeholder.2c175caca866dfbe901a97cd6bfe3c7a.svg";
export { ForwardRef as ReactComponent };